import {HttpRequest} from "./HttpRequest";
import {CdnLibrary} from "../const/common";
import {Toast} from 'mint-ui';
import store from "./store";

class ProjectData extends HttpRequest {
  constructor(vue) {
    super(vue);
  }

  getStoryList(suc, err, caller) {
    this.httpRequestData(CdnLibrary.request.GET_PROJECT_LG + '?token='+ window.orgUser.GetLoginToken() + '&source=' + 2 + '&v=' + new Date().getTime(), null, suc, err, caller, false);
  }
  release(pmode, call,caller){
    var binPath = "/canvas/res/test.bin";
    Middle.ServerPort.GetInstance().publishGame(pmode, binPath, call,caller);
  }
  saveStory(call,caller){
    Middle.ProjectData.header.name = store.state.storyName;
    Middle.ServerPort.GetInstance().saveProject(call,caller);
  }

}
export {ProjectData}



// WEBPACK FOOTER //
// ./src/store/ProjectData.js